// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 2619) return "static/chunks/2619-e6cb6cc2572e4af5.js";
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"5729":"81cc64830b5a16a6","9637":"79ba400927852b6d"}[chunkId] + ".js";
};